/*
  * Used for changing the state or data
*/
import Vue from 'vue';
import moment from 'moment';
import Vuex from 'vuex';
import Axios from 'axios';
import * as _ from 'lodash';
import { Utilities } from '../../../../shared/utilities';
import { http } from '@/shared/https';

Vue.use(Vuex, Axios);

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        autoFit: false,
        searchTitle: '',
        buttonList: {
            add: {
                title: 'Add',
                module: 'common',
                icon: 'mdi-plus'        
            }
        },
        security: null,
        mobileAppName: null,
        mobileApp: false,
        exportFileName: null,
        menuTitle: '',
        initialValue: null,
        breadCrumb: '',
        name: '',
        renderSearch: false,
        template: {},
        search: null,
        cards: [],
        title: [],
        tooltip: [],
        close: true,
        uppercase: false,
        tabularForm: false,
        tabularTitle: true,
        tabularList: [],
        requiredMsg:false, //Added by Arun
        tabs: [],
        openNodes: [],
        tree: [],
        activeMenuTab: ""
    },

    //#. Used to access data from the state tree of the store
    getters: {
        /*
            * Render component back in...
        */ 
        renderComponent(state) {
            //#.Remove component in the DOM.
            state.renderComponent = false;

            Vue.nextTick(() => {
                //#.Add the component back in
                state.renderComponent = true;
            });
        },

        /*
            * Remove component in the DOM...
        */
        removeComponent(state) {
            Vue.nextTick(() => {
                //#.Add the component back in
                state.renderComponent = false;
            });
        }
    },

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {

        //#. fn_search function
        search(state, payload) {
            //#. Remove the title search buttons in the DOM
            payload.renderTitleSearchComponent = false;

            //#. Set focus on title search field
            setTimeout(() => {
                // @ts-ignore
                $('#' + payload.moduleName).find('.main-search input').first().focus().val();
            }, 50);
        },

        //#. fn_search cancel function
        removeSearch(state, payload) {
            //#. Add the search button back in
            payload.renderTitleSearchComponent = true;

            //#. Reset title value in the input
            setTimeout(() => {
                 // @ts-ignore
                $('#' + payload.moduleName).find('.main-search input').first().blur().val(payload.title);
            }, 10);
        },

        //#. fn_formAdd function
        add({ commit, dispatch }, payload) {
            let field = null, context = payload.context;

            //#.Check if the componet is add / edit form
            if (!context.parentComponent && context.dashboard.componentId == 0) {
                //#.Enable notify are triggered with the store.dispatch method.
                 // @ts-ignore
                this.dispatch('dashboard/enableNotify', { color: 'error', text: context.messages.cardFill });
                return;
            }

            //#. When clicking add button, redirect to the another profile
            if (context.redirect) {
                //#.beforeRedirect are triggered with the store.dispatch method.
                // @ts-ignore
                this.dispatch(payload.self.$options.parent.fileName + '/beforeRedirect', { state: payload.self.$store.state, data: context });

                window.location.href = context.redirect.action + '?mId=' + context.redirect.menuId + '#' + 0;

                //#. Check if the component is reloaded the same dashboard
                if (context.redirect.action == window.location.pathname) {
                    context.dashboard.renderComponent = false;
                    context.dashboard.componentId = 0;

                    payload.self.$nextTick(() => {
                        //#. Add the component back in
                        context.dashboard.renderComponent = true;
                    });
                }
                return;
            }

            //#.Find the current operation
            context.formCreate = true;

            //#.Enable the disabled fields
            context.disabled = false;

            //#.Enable the disabled save button
            context.buttonDisabled = false;

            //#.Check if the componet is inline editor
            if (context.inlineEditor.enabled) {
                let defaultRowData = {};

                if (context.editedIndexArray.length > 0) {
                    context.isDirty = true;
                    //#.Find the current operation
                    context.formCreate = false;
                    let key = null;

                    if (context.editedIndex != null && context.editedIndex != -1) {
                        // @ts-ignore
                        key = context.formData[context.editedIndex][context.fields.find(x => x.primaryKey == true).value];
                    }

                    if (key == "" || key == 0 || key == null) {
                        //#.Find the current operation
                        context.formCreate = true;
                    }

                    //#.Enable notify are triggered with the store.dispatch method.
                    // @ts-ignore
                    this.dispatch('dashboard/enableNotify', { color: 'error', text: context.messages.rowFill });
                    return;
                }

                //#.Assigning title default value in the field
                context.editedItem = Object.assign({}, context.defaultItem);

                //#.Reset all the default values in fields
                context.fields.filter(x => x.list != false).forEach(key => {
                    defaultRowData[key.value] = context.defaultItem[key.value];

                    if (payload.context.defaultItem[key.value] && key.displayCurrentDate)
                        return;

                    if (context.defaultItem[key.value] && !key.defaultValue)
                        defaultRowData[key.value] = null;
                });

                //#.Temporarily store the new records
                context.tempData.push(defaultRowData);

                //#.formCreated event raising methods
                // @ts-ignore
                this.dispatch(context.fileName + '/formCreated', context);

                //#.Newly added records pused to form data
                context.formData.push(defaultRowData);

                //#.Check if the new record index
                context.editedIndex = context.formData.indexOf(defaultRowData);
                context.editedIndexArray.push(context.editedIndex);

                //#.Set focus on first editable field
                field = context.fields.filter(x => x.primaryKey != true && x.readonly != true && x.parent != true && x.create != false).find(x => x).value;

                //#.rowSelection event raising methods
                // @ts-ignore
                this.dispatch('rowSelection', { item: defaultRowData, context }, { root: true });

                //#. Checking switch input
                let switchInput = context.fields.filter(x => x.type == 'SwitchInput');

                if (switchInput.length > 0) {
                    //#.Remove the component in the DOM
                    context.switches = false;

                    Vue.nextTick(() => {
                        //#.Add the component back in
                        context.switches = true;
                    });
                }

                return;
            }

            //#.Assigning title default value in the field
            context.editedItem = Object.assign({}, context.defaultItem);

            //#.formCreated event raising methods
            // @ts-ignore
            this.dispatch(context.fileName + '/formCreated', context, { root: true });

            //#.Apply Dialog css 
            if ((context.multiColumn == 1 && !context.fullScreen) || context.isMobile == true) {
                context.dialogClass = 'dialog-width-sm';
            } else if (context.multiColumn == 2 && !context.fullScreen) {
                context.dialogClass = 'dialog-width-md';
            } else if ((context.multiColumn == 3 || context.multiColumn == 4) && !context.fullScreen) {
                context.dialogClass = 'dialog-width-lg';
            }

            if ((context.dialogPosition == 'bottom' && !context.fullScreen) && !context.isMobile) {
                context.dialogClass = context.dialogClass + ' ' + 'bottom';
            } else if ((context.dialogPosition == 'top' && !context.fullScreen) && !context.isMobile) {
                context.dialogClass = context.dialogClass + ' ' + 'top';
            }
            
            //#.Add dialog component back in
            context.dialog = true;
            context.editedIndex = -1;

            //#.Set focus on first editable field
            field = context.fields.filter(x => x.primaryKey != true && x.readonly != true && x.parent != true && x.create != false).find(x => x).value;

            if (context.orginTitle && context.orginTitle.includes("{")) {
                return;
            }
        },

        //#. fn_formEdit function
        edit(state, payload) {
            let field = null;

            //#.Enable the disabled save button
            payload.buttonDisabled = false;

            //#.Assigning editItem based on the index
            payload.editedIndex = 0;

            //#.Checking of security part
            if (payload.permissions.indexOf('E') != -1) {
                payload.disabled = false;
            }

            //#.Set focus on first editable field
            field = payload.fields.filter(x => x.primaryKey != true && x.readonly != true && x.parent != true && x.type != 'Hidden').find(x => x).value;
   
            if (payload.orginTitle.includes("{")) {
                return;
            }
        },

        //#. fn_formCancel function
        removeEdit(state, payload) {
            let records = {};

            //#. Check for workflow implementation
            if (payload.context.parentComponent && payload.context.workflow.workflowImplemented) {
                payload.context.workflow.tooltipContainer = false;
            }

            //#.Check if the componet is add / edit form
            if (state.componentId == 0) {
            
                //#.Reset all the defaultValue fields
                payload.context.fields.filter(x => x.defaultValue).forEach(key => {
                    records[key.value] = key.dropdown.filter(x => x.Value == key.defaultValue).find(x => x).DisplayText;
                });
            
                //#.Reset all the displayCurrentDate fields
                payload.context.fields.filter(x => x.displayCurrentDate).forEach(key => {
                    records[key.value] = moment(key.currentDate, key.hint).format(payload.context.defaultDateFormat);
                    key.date = key.currentDate;

                    payload.context.editedItem[key.value] = records[key.value];
                });

                //#. Check for workflow implementation
                if (payload.context.parentComponent && payload.context.workflow.workflowImplemented) {
                    records[payload.context.workflow.workflowStepId] = payload.context.editedItem[payload.context.workflow.workflowStepId];
                }

                //#.Reset the all changed input values to default value
                payload.context.editedItem = records;
            
                //#.Reset the component title.
                if (payload.context.titleSearch) {
                    payload.context.title = null;
                }
            
                return;
            }

            //#. Check for the workflow comments.
            if (payload.context.parentComponent && payload.context.workflow.workflowImplemented) {
                //#. Remove the component in the DOM
                payload.context.workflow.workflowImplemented = false;
                payload.context.workflow.comments = false;               
                payload.context.editedItem = payload.context.workflow.optionsList.find(x => x.Value == payload.context.formData.WorkFlowStatusId).DisplayText;
                //#. Check for the index
                payload.context.workflow.currentStep = payload.context.workflow.optionsList.indexOf(payload.context.workflow.optionsList.find(x => x.Value == payload.context.formData.WorkFlowStatusId));

                Vue.nextTick(() => {
                    //#. Add the component back in
                    payload.context.workflow.workflowImplemented = true;
                });               
            }

            //#.Fetch server record value
            _.forOwn(payload.context.mapItem, function (key, val) {
                records[val] = key;
            });
            
            //#.Reset the all changed input values
            payload.context.editedItem = records;
            
            //#.Disable the all enabled input fields
            payload.context.disabled = true;
            payload.context.editedIndex = -1;

            //#.Assigning title value to the title serach field. 
            if (payload.context.titleSearch) {
                let fieldName = payload.context.orginTitle.substr(2).slice(0, -2);
                payload.context.title = records[fieldName];
            }   
        },

        removeComponent(state, payload) {
            state.renderComponent = false;
            state.componentId = payload;
        },

        renderComponent(state, payload) {
            state.renderComponent = true;
        },

        enableNotify(state, payload) {
            state.notify.enabled = true;
            state.notify.text = payload.text;
            state.notify.color = payload.color;
            state.notify.item = payload.record;
            state.notify.name = payload.name;
            state.notify.type = payload.type;
        },

        appClose(state, payload) {
            //#.Checking router history
            let root = state.RootApp;
            let rootState = payload.self.$store.state;
            let translate = payload.self.$vuetify.lang;

            //#.Checking router history
            if (root.routers.length == 0) {
                //#.Get local storage information
                root.routers = localStorage.getItem("routers");
                if (root.routers != "") root.routers = JSON.parse(root.routers);
        
                localStorage.setItem("routers", "");
            }
        
            //#.Removing last url path.
            if (root.routers.length != 0) {
                //#.Update router array list.
                delete root.routers[root.routers.length - 1];
                root.routers.length = root.routers.length - 1;
                localStorage.setItem("routers", JSON.stringify(root.routers));
        
                if (root.routers.length == 1) {
                root.profileClosePath = root.routers[0];
                //#.Update url history
                history.pushState(
                    { id: "", }, "", root.profileClosePath
                );
                } else if (root.routers.length != 0) {
                    root.profileClosePath = root.routers[root.routers.length - 1];
                    //#.Update url history
                    history.pushState(
                        {
                        id: "",
                        },
                        "",
                        root.profileClosePath
                    );
                }
            }
        
            //#.Remove extraParams in axios.
            localStorage.setItem("extraParams", "");
            // @ts-ignore
            payload.self.$store.state.dashboard.extraParams = null;
        
            //#.Static methods for fetch menu id
            let menuId = Utilities.getParameterByName("mId");
        
            //#.Reset breadcrumbs
            // this.settings.breadcrumbs.list = [];
        
            // if (root.menu.tree.length == 0) {
            //   let crumbs = localStorage.getItem("breadcrumbs");
        
            //   if (crumbs != null && crumbs != "")
            //     this.settings.breadcrumbs.list = JSON.parse(crumbs);
            // } else {
            //   this._appGenerateBreadcrumbs(root.menu.tree, menuId);
            // }
        
            // root.breadcrumbs.enabled = true;
        
            return http.get(root.actions.getTemplates + menuId).then((record) => {
                if (record.data.Result == "OK") {
                // @ts-ignore
                let payload = rootState.dashboard;
        
                //#.Update component id
                if (root.profileClosePath != "") {
                    let path = root.profileClosePath.split("#");
        
                    if (path.length == 1) {
                    payload.componentId = 0;
                    } else {
                    payload.componentId = path[1];
                    }
                }
        
                // @ts-ignore
                payload.security = [];
                payload.template = JSON.parse(record.data.Template);
                payload.cards = record.data.Component;
                payload.title = record.data.Caption;
                payload.tooltip = record.data.Tooltip;
                payload.search = record.data.SearchURL;
                payload.searchComponent =
                    record.data.SearchName == null ? false : record.data.SearchName;
                payload.breadCrumb = record.data.BreadCrumb;
                payload.close = payload.template.close;
                payload.tabularList = record.data.Tabular;
        
                //#.Checking enable / disable component close
                if (payload.close) {
                    root.profileClose = true;
                } else {
                    root.profileClose = false;
                }
        
                //#.Auto fit template enabled.
                if (payload.template.autofit == true) {
                    payload.autoFit = true;
                }
        
                //#.Enabled filter component
                if (payload.template.reportFilter == true) {
                    let reportCards = [],
                    cardTitle = [];
                    // @ts-ignore
                    reportCards.push("FilterComponent");
                    // @ts-ignore
                    reportCards.push(payload.cards[0]);
                    // @ts-ignore
                    cardTitle.push("Filter");
                    // @ts-ignore
                    cardTitle.push(payload.title[0]);
        
                    payload.cards = reportCards;
                    payload.title = cardTitle;
                }
        
                //#.Tabular form template enabled.
                if (payload.template.tabularform == true) {
                    payload.tabularForm = true;
                }
        
                //#.Check if the component is mobile app
                if (payload.template.mobileApp == true) {
                    payload.mobileApp = true;
                }
        
                //#.Apply translation to messages
                if (payload.keyTranslator) {
                    _.forOwn(payload.messages, function (key, val) {
                    if (val.indexOf("_") == -1 && !payload.messages["_" + val])
                        payload.messages["_" + val] = key;
        
                    if (val.indexOf("_") == -1)
                        payload.messages[val] =
                        translate.locales[translate.current][
                            payload.messages["_" + val]
                        ] || payload.messages["_" + val];
                    });
                }
        
                //#.Update component title
                payload.cards
                    .filter((x) => x)
                    .forEach((key) => {
                    let componentName =
                        key.charAt(0).toLowerCase() +
                        key.slice(1).replace("Component", "");
                    componentName = componentName + "Index";
        
                    //#.Index of the components
                    let index = payload.cards.indexOf(key);
        
                    if (!rootState[componentName]) {
                        return;
                    }
        
                    rootState[componentName].card.multiColumn =
                        rootState[componentName].multiColumn || "Auto";
        
                    //#.Checking workflow implementation
                    if (rootState[componentName].fields.WorkFlowStatusId) {
                        rootState[componentName].fields.WorkFlowStatusId.value =
                        rootState[componentName].workflow.workflowStepId;
                        rootState[componentName].fields.Comments.value =
                        rootState[componentName].workflow.workflowComments;
                    }
        
                    if (!_.includes(payload.title[payload.cards.indexOf(key)], "{{")) {
                        rootState[componentName].title =
                        payload.title[payload.cards.indexOf(key)];
        
                        //#.Header list
                        let header = [],
                        totalFields,
                        fieldsList = [];
                        rootState[componentName].landscape = true;
        
                        // @ts-ignore
                        _.forOwn(rootState[componentName].fields, function (key, val) {
                        if (
                            key.primaryKey != true &&
                            key.parent != true &&
                            key.list != false &&
                            key.type != "Hidden"
                        ) {
                            if (!key.orgTitle) key.orgTitle = key.title;
        
                            if (payload.keyTranslator)
                            key.text =
                                translate.locales[translate.current][key.orgTitle] ||
                                key.orgTitle;
                            else key.text = key.title;
        
                            key.title = key.text;
                            // @ts-ignore
                            header.push(key);
                        }
        
                        if (
                            !key.primaryKey &&
                            key.type != "Hidden" &&
                            !key.create &&
                            !key.parent
                        ) {
                            // @ts-ignore
                            fieldsList.push(key.value);
                        }
                        });
        
                        rootState[componentName].headers = header;
        
                        if (
                        rootState[componentName].card.type !=
                        rootState[componentName].type._tree
                        ) {
                        totalFields = fieldsList.length;
        
                        //Auto arrange the field layout
                        if (rootState[componentName].multiColumn == "Auto") {
                            if (totalFields >= 1 && totalFields <= 6) {
                            rootState[componentName].card.multiColumn = 1;
                            } else if (totalFields >= 7 && totalFields <= 12) {
                            rootState[componentName].card.multiColumn = 2;
                            } else if (totalFields >= 12 && totalFields <= 18) {
                            rootState[componentName].card.multiColumn = 3;
                            } else {
                            rootState[componentName].card.multiColumn = 4;
                            }
        
                            rootState[componentName].multiColumn =
                            rootState[componentName].card.multiColumn;
                        } else {
                            rootState[componentName].card.multiColumn =
                            rootState[componentName].multiColumn;
                        }
        
                        if (rootState[componentName].multiColumn > 2) {
                            rootState[componentName].landscape = false;
                        }
        
                        if (rootState[componentName].inlineEditor.enabled) {
                            rootState[componentName].landscape = false;
                        }
                        }
                    } else {
                        rootState[componentName].titleSearch = true;
                        let title = payload.title[index].substr(2).slice(0, -2);
                        rootState[componentName].headerTooltip =
                        rootState[componentName].fields[title].title;
                    }
                    });
        
                payload.renderComponent = false;
        
                Vue.nextTick(() => {
                    // @ts-ignore
                    payload.renderComponent = true;
                });
                }
            });  
        },

        rowSelection(state, payload) {
            payload.context.activeRow = payload.item;
        },

        mobileButtonAction({ commit, dispatch }, payload) {
            if (payload.data.module != 'common') {
                //#.Triggered button action with the store.dispatch method.
                // @ts-ignore
                this.dispatch(payload.data.module + '/' + payload.data.function);
                return;
            }

            let context = payload.context,
                field = null;

            //#.Check if the componet is add / edit form
            if (!context.parentComponent && context.dashboard.componentId == 0) {
                //#.Enable notify are triggered with the store.dispatch method.
                // @ts-ignore
                this.dispatch('enableNotify', { color: 'error', text: context.messages.cardFill });
                return;
            }

            //#. When clicking add button, redirect to the another profile
            if (context.redirect) {
                //#.beforeRedirect are triggered with the store.dispatch method.
                // @ts-ignore
                this.dispatch(state.mobileAppName + '/beforeRedirect', { state: state, data: context });

                window.location.href = context.redirect.action + '?mId=' + context.redirect.menuId + '#' + 0;

                //#. Check if the component is reloaded the same dashboard
                if (context.redirect.action == window.location.pathname) {
                    context.dashboard.renderComponent = false;
                    context.dashboard.componentId = 0;
                    // @ts-ignore
                    this.$nextTick(() => {
                        //#. Add the component back in
                         // @ts-ignore
                        context.dashboard.renderComponent = true;
                    // @ts-ignore
                    });
                }
                return;
            }

            //#.Find the current operation
            context.formCreate = true;

            //#.Enable the disabled fields
            context.disabled = false;

            //#.Enable the disabled save button
            context.buttonDisabled = false;

            //#.Check if the componet is inline editor
            if (context.inlineEditor.enabled) {
                let defaultRowData = {};

                if (context.editedIndexArray.length > 0) {
                    context.isDirty = true;
                    //#.Find the current operation
                    context.formCreate = false;
                    let key = null;

                    if (context.editedIndex != null && context.editedIndex != -1) {
                        key = context.formData[context.editedIndex][context.fields.find(x => x.primaryKey == true).value];
                    }

                    if (key == "" || key == 0 || key == null) {
                        //#.Find the current operation
                        context.formCreate = true;
                    }

                    //#.Enable notify are triggered with the store.dispatch method.
                    // @ts-ignore
                    this.dispatch('enableNotify', { color: 'error', text: context.messages.rowFill });
                    return;
                }

                //#.Assigning title default value in the field
                // @ts-ignore
                this.editedItem = Object.assign({}, context.defaultItem);

                //#.Reset all the default values in fields
                context.fields.filter(x => x.list != false).forEach(key => {
                    defaultRowData[key.value] = context.defaultItem[key.value];

                    if (context.defaultItem[key.value] && !key.defaultValue)
                        defaultRowData[key.value] = null;
                });

                //#.Temporarily store the new records
                context.tempData.push(defaultRowData);

                //#.formCreated event raising methods
                // @ts-ignore
                this.dispatch(context.fileName + '/formCreated', context);

                //#.Newly added records pused to form data
                context.formData.push(defaultRowData);

                //#.Check if the new record index
                context.editedIndex = context.formData.indexOf(defaultRowData);
                context.editedIndexArray.push(context.editedIndex);

                //#.Set focus on first editable field
                field = context.fields.filter(x => x.primaryKey != true && x.readonly != true && x.parent != true && x.create != false).find(x => x).value;
                
                //#.rowSelection event raising methods
                // @ts-ignore
                this.dispatch('rowSelection', { item: defaultRowData, context }, { root: true });

                //#. Checking switch input
                let switchInput = context.fields.filter(x => x.type == 'SwitchInput');

                if (switchInput.length > 0) {
                    //#.Remove the component in the DOM
                    context.switches = false;

                    Vue.nextTick(() => {
                        //#.Add the component back in
                        context.switches = true;
                    });
                }

                return;
            }

            // #.Assigning title default value in the field
            // @ts-ignore
            this.editedItem = Object.assign({}, context.defaultItem);

            // #.formCreated event raising methods
            // @ts-ignore
            this.$store.dispatch(context.fileName + '/formCreated', context);

            // #.Add dialog component back in
            // @ts-ignore
            this.dialog = true;
        },

        //#. fn_dataTable function
        _dtEdit(state, payload) {
            let field = null,
                isEdit = false;

            //#.Check if the componet is inline editor auto save enabled and empty row false
            if (payload.context.inlineEditor.enabled && (!payload.context.inlineEditor.emptyRow || payload.context.inlineEditor.emptyRow && (payload.context.formData.indexOf(payload.item) != (payload.context.formData.length - 1)))) {
                let fieldObj = payload.context.fields.find(x => x.value == payload.fieldName);

                if (payload.fieldName && fieldObj.download)
                    return;

                if (payload.fieldName && fieldObj.mailto && fieldObj.mailto.enabled)
                    return;

                if (payload.context.permissions.indexOf('E') == -1)
                    return;

                if (!payload.context.inlineEditor.emptyRow && payload.context.inlineEditor.autoSave && payload.context.tempData.length > 0 && payload.context.tempData.indexOf(payload.item) == -1) {
                    //#.Enable notify are triggered with the store.dispatch method.
                    // @ts-ignore
                    this.dispatch('dashboard/enableNotify', { color: 'error', text: payload.context.messages.rowFill });
                    return;
                }
            }

            //#.Check if the row is editable mode
            if (payload.context.editedIndexArray && payload.context.editedIndexArray.length > 0 && payload.fieldName && payload.context.editedIndexArray[0] == payload.context.editedIndex) {
                payload.context.rowIndex = payload.context.formData.indexOf(payload.item);

                if (payload.context.editedIndexArray[0] == payload.context.rowIndex)
                    return;
            }

            //#.Check if the componet is inline editor auto save enabled
            if (payload.context.inlineEditor.enabled && payload.context.inlineEditor.autoSave) {
                payload.context.copyEditedIndex = null;
                payload.context.editedIndexArray = [];
            }

            //#.Check if the componet is inline editor
            if (payload.context.inlineEditor.enabled) {
                if (!payload.context.inlineEditor.autoSave && payload.context.editedIndexArray.length > 0) {
                    //#.Enable notify are triggered with the store.dispatch method.
                    // @ts-ignore
                    this.dispatch('dashboard/enableNotify', { color: 'error', text: payload.context.messages.rowFill });
                    return;
                }

                //#.Check if the input is already modify
                if (payload.context.inlineEditor.autoSave && payload.context.isDirty) {
                    let items = payload.context.formData[payload.context.editedIndex];
                    payload.context.copyEditedIndex = payload.context.formData.indexOf(payload.item);
                    payload.context.copyEditedItem = payload.context.editedItem;

                    if (items) {
                        isEdit = true;
                        // @ts-ignore
                        payload.self._inlSave(items);
                    }
                }
            }

            //#.Disable the enabled save button
            payload.context.buttonDisabled = false;

            //#.Reset the current operation
            payload.context.formCreate = false;

            //#.Checking of security part
            if (payload.context.permissions.indexOf('E') != -1) {
                payload.context.disabled = false;
            }

            //#.Assigning editItem based on the index
            if (payload.context.inlineEditor.autoSave && !isEdit)
                payload.context.editedIndex = payload.context.formData.indexOf(payload.item);
            else if (!payload.context.inlineEditor.autoSave)
                payload.context.editedIndex = payload.context.formData.indexOf(payload.item);

            if (payload.context.card.type == payload.context.type._treeTable) {
                let primaryKey = payload.context.fields.filter(x => x.primaryKey == true).find(x => x).value;
                payload.context.editedIndex = payload.item[primaryKey];
            }

            payload.context.editedItem = Object.assign({}, payload.item);

            //#.formCreated event raising methods
            // @ts-ignore
            this.dispatch(payload.context.fileName + '/formCreated', payload.context);

            //#. find first editable field
            field = payload.context.fields.filter(x => x.primaryKey != true && x.readonly != true && x.parent != true && x.edit != false && x.type != 'Hidden').find(x => x).value;

            //#.Check form action be direct form submit or not
            if (!payload.context.ajaxFormSubmit) {
                payload.context.editedItem["FormData"] = new FormData();
            }

            //#.Check if the componet is inline editor
            if (payload.context.inlineEditor.enabled) {
                //#.Store the updated records index
                payload.context.editedIndexArray.push(payload.context.editedIndex);

                if (payload.fieldName)
                    field = payload.fieldName;

                return;
            }

            //#. Add the dialog component back in
            payload.context.dialog = true;

            setTimeout(() => {
                //payload.self.$parent.$parent.$children[0].$children[2].$refs[field][0].$refs[field].focus();
            }, 50);
        },

        //#. fn_dataTable delete function
        _dtDelete(state, payload) {
            if (payload.context.permissions.indexOf('D') == -1) {
                //#.Enable notify are triggered with the store.dispatch method.
                // @ts-ignore
                this.dispatch('dashboard/enableNotify', { color: 'info', text: payload.context.messages.permissionWarn });
                return
            }
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        getTemplate: ({ commit, rootState, dispatch }, payload) => {
            let menuId = Utilities.getParameterByName('mId');
            return http.get(payload.context.getTemplate + menuId).then(record => {
                if (record.data.Result == 'OK') {
                    let routerList = localStorage.getItem('routers');
                   
                    //#.Checking current router path.
                    if (payload.context.RootApp.profileClosePath == "" &&
                        routerList != "" && routerList != "[]") {

                        //#.Get router path details
                        payload.context.RootApp.routers = localStorage.getItem('routers');
                        let url = JSON.parse(payload.context.RootApp.routers);

                        // if (url && url.length == 1)
                        //     payload.context.RootApp.profileClosePath = url[0];
                        // else
                        //     payload.context.RootApp.profileClosePath = url[url.length - 2];

                        payload.context.RootApp.routers = [];
                    }

                    // @ts-ignore
                    payload.context.security = [];
                    payload.context.template = JSON.parse(record.data.Template);
                    payload.context.cards = record.data.Component;
                    payload.context.title = record.data.Caption;
                    payload.context.tooltip = record.data.Tooltip;
                    payload.context.search = record.data.SearchURL;
                    payload.context.searchComponent = (record.data.SearchName == null ? false : record.data.SearchName);
                    payload.context.breadCrumb = record.data.BreadCrumb;
                    payload.context.close = payload.context.template.close;
                    payload.context.tabularList = record.data.Tabular;
                    payload.context.autoFit = false;
                    payload.context.tabularForm = false;
                    payload.context.mobileApp = false;

                    //#.Document feature
                    if (payload.context.template.document == true) {
                        payload.context.cards.push("DocumentComponent");
                        payload.context.title.push("Documents");
                    }

                    //#.Auto fit template enabled.
                    if (payload.context.close) {
                        payload.context.RootApp.profileClose = true;
                    } else {
                        payload.context.RootApp.profileClose = false;
                    }
                   
                    //#.Auto fit template enabled.
                    if (payload.context.template.autofit == true) {
                        payload.context.autoFit = true;
                    } 

                    //#.Tabular form template enabled.
                    if (payload.context.template.tabularform == true) {
                        payload.context.tabularForm = true;
                    }

                    //#.Check if the component is mobile app
                    if (payload.context.template.mobileApp == true) {
                        payload.context.mobileApp = true;
                    }

                    //#.Apply translation to messages
                    if (payload.context.keyTranslator) {
                        _.forOwn(payload.context.messages, function (key, val) {

                            if (val.indexOf('_') == -1 && !payload.context.messages["_" + val])
                                payload.context.messages["_" + val] = key;

                            if (val.indexOf('_') == -1)
                                payload.context.messages[val] = payload.lang.locales[payload.lang.current][key] || key;
                        });
                    }

                    //#.Update component title
                    payload.context.cards.filter(x => x).forEach(key => {
                        let componentName = key.charAt(0).toLowerCase() + key.slice(1).replace('Component', '');
                        componentName = componentName + (componentName !== 'document' ? 'Index' : "");

                        //#.Index of the components
                        let index = payload.context.cards.indexOf(key);
                       
                        rootState[componentName].card.multiColumn = rootState[componentName].multiColumn || 'Auto';

                        //#.Checking workflow implementation
                        if (rootState[componentName].fields.WorkFlowStatusId) {
                            rootState[componentName].fields.WorkFlowStatusId.value = rootState[componentName].workflow.workflowStepId;
                            rootState[componentName].fields.Comments.value = rootState[componentName].workflow.workflowComments;
                        }

                        if (!_.includes(payload.context.title[payload.context.cards.indexOf(key)], '{{')) {
                            rootState[componentName].title = payload.context.title[payload.context.cards.indexOf(key)];

                            //#.Header list
                            let header = [], totalFields, fieldsList = [];
                            rootState[componentName].landscape = true;

                            _.forOwn(rootState[componentName].fields, function (key, val) {
                                if (key.primaryKey != true && key.parent != true && key.list != false && key.type != 'Hidden') {
                                    if (!key.orgTitle)
                                        key.orgTitle = key.title;

                                    if (payload.keyTranslator)
                                        key.text = payload.lang.locales[payload.lang.current][key.orgTitle] || key.orgTitle;
                                    else
                                        key.text = key.title;

                                    key.title = payload.self.$t(key.text);

                                    key.orgTitle = key.title;
                                    // @ts-ignore
                                    header.push(key);
                                }

                                if (!key.primaryKey && key.type != 'Hidden' && !key.create && !key.parent) {
                                    // @ts-ignore
                                    fieldsList.push(key.value);
                                }
                            });

                            rootState[componentName].headers = header;

                            if (rootState[componentName].card.type != rootState[componentName].type._tree) {
                                totalFields = fieldsList.length;

                                //Auto arrange the field layout
                                if (rootState[componentName].multiColumn == 'Auto') {
                                    if (totalFields >= 1 && totalFields <= 6) {
                                        rootState[componentName].card.multiColumn = 1;
                                    } else if (totalFields >= 7 && totalFields <= 12) {
                                        rootState[componentName].card.multiColumn = 2;
                                    } else if (totalFields >= 12 && totalFields <= 18) {
                                        rootState[componentName].card.multiColumn = 3;
                                    } else {
                                        rootState[componentName].card.multiColumn = 4;
                                    }

                                    rootState[componentName].multiColumn = rootState[componentName].card.multiColumn;
                                } else {
                                    rootState[componentName].card.multiColumn = rootState[componentName].multiColumn;
                                }

                                if (rootState[componentName].multiColumn > 2) {
                                    rootState[componentName].landscape = false;
                                }

                                if (rootState[componentName].inlineEditor.enabled) {
                                    rootState[componentName].landscape = false;
                                }
                            }
                        } else {
                            rootState[componentName].titleSearch = true;
                            let title = (payload.context.title[index]).substr(2).slice(0, -2);
                            rootState[componentName].headerTooltip = rootState[componentName].fields[title].title;
                        }
                    });
                    // Added below code to render admin dashboard on login
                    payload.context.renderComponent = false;
                    Vue.nextTick(() => {
                        // @ts-ignore
                        payload.context.renderComponent = true;
                    });
                }
            }).catch(error => {
            });
        },

        //#. Enable notify component
        enableNotify: ({ commit }, payload) => {
            commit('enableNotify', payload);
        },

        //#. Remove the existing component
        removeComponent: ({ commit }, payload) => {
            commit('removeComponent', payload);
        },

        //#. Add the component back in
        renderComponent: ({ commit }, payload) => {
            commit('renderComponent', payload);
        },

        //#. Enable row selection ui
        rowSelection: ({ commit }, payload) => {
            commit('rowSelection', payload);
        },

        //#. Mobile button action
        mobileButtonAction: ({ commit }, payload) => {
            commit('mobileButtonAction', payload);
        },

        //#. add event will be fired
        add: ({ commit }, payload) => {
            commit('add', { context: payload.context, self: payload.self });
        },
      
        //#. edit event will be fired
        edit: ({ commit, dispatch }, context) => {
            commit('edit', context);            
        },

        //#. data table edit event will be fired
        _dtEdit: ({ commit, dispatch }, context) => {
            commit('_dtEdit', context);
        },

        //#. data table delete event will be fired
        _dtDelete: ({ commit, dispatch }, context) => {
            commit('_dtDelete', context);

            //#.Enable notify are triggered with the store.dispatch method.
            dispatch('enableNotify', { color: 'confirm', text: context.context.messages.deleteConfirm, record: context.item, name: context.name, type: 'delete' });
        },

        //#. search event will be fired
        search: ({ commit }, payload) => {
            commit('search', payload);
        },

        //#. remove search event will be fired
        removeSearch: ({ commit }, payload) => {
            commit('removeSearch', payload);
        },

        //#. remove edit event will be fired
        removeEdit: ({ commit, dispatch }, payload) => {
            commit('removeEdit', { context: payload.context, self: payload.self });
        },

        appClose: ({ commit, dispatch }, payload) => {
            commit('appClose', { context: payload.context, self: payload.self });
        }
    }
}
